import { css } from 'styled-components';

export const DropdownContainer = css`
    &:focus-visible {
        outline: none;
    }
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
`;
